import { useVIPEditDeleteVIPMutation } from '@graphql/generated';
import { useTranslation } from '@shared/core';
import { useToast } from '@withjoy/joykit';
import { useCallback } from 'react';

export const useDeleteVip = () => {
  const [mutation] = useVIPEditDeleteVIPMutation();
  const { tq } = useTranslation('VIPCustomComponent');
  const { toast } = useToast();

  const deleteVIP = useCallback(
    async (id: string) => {
      try {
        const results = await mutation({
          variables: {
            payload: {
              id,
            },
          },
        });
        return results.data?.deleteVip ?? null;
      } catch (error) {
        toast(tq`Error deleting VIP`);
        return null;
      }
    },
    [mutation, toast, tq],
  );

  return { deleteVIP };
};
